/*******************************************************************************
 * resend-remittances.js - Resend Remittances Feature
 ******************************************************************************/

const { ELEMENT_IDS, API_ENDPOINTS } = window;
const { getElement, showElement, hideElement, showDialog, hideDialog } = window;
const { logToServer } = window;

const resendRemittances = {
    selectedContacts: [],
    invoiceGroups: [],

    /**
     * Opens the resend remittances modal dialog
     * Resets all state and prepares the UI for a new search
     */
    openModal: function() {
        var dialogEl = getElement(ELEMENT_IDS.RESEND_DIALOG);
        if (!dialogEl || !dialogEl.ej2_instances) {
            logToServer("error", "Resend remittances dialog not found", {});
            alert("Dialog not ready. Please refresh the page.");
            return;
        }
        
        var dialog = dialogEl.ej2_instances[0];
        showDialog(ELEMENT_IDS.RESEND_DLG_CONTAINER);
        
        // Reset state
        this.selectedContacts = [];
        this.invoiceGroups = [];
        hideElement(ELEMENT_IDS.RESEND_RESULTS_CONTAINER);
        hideElement(ELEMENT_IDS.RESEND_NO_RESULTS);
        hideElement(ELEMENT_IDS.RESEND_LOADING);
        hideElement(ELEMENT_IDS.RESEND_PROGRESS_CONTAINER);
        var sendBtn = getElement(ELEMENT_IDS.BTN_RESEND_SEND);
        if (sendBtn) sendBtn.disabled = true;
        var selectAllCb = getElement(ELEMENT_IDS.RESEND_SELECT_ALL);
        if (selectAllCb) selectAllCb.checked = false;
        this.updateSelectedCount();
        
        dialog.show();
        
        // Set up button handlers
        var cancelBtn = getElement(ELEMENT_IDS.BTN_RESEND_CANCEL);
        if (cancelBtn) {
            cancelBtn.onclick = function() {
                dialog.hide();
            };
        }
        
        if (sendBtn) {
            sendBtn.onclick = function() {
                resendRemittances.sendRemittances();
            };
        }
    },

    /**
     * Searches for paid invoices within the selected date range
     */
    search: function() {
        var startDateEl = getElement(ELEMENT_IDS.RESEND_START_DATE);
        var endDateEl = getElement(ELEMENT_IDS.RESEND_END_DATE);
        if (!startDateEl || !endDateEl || !startDateEl.ej2_instances || !endDateEl.ej2_instances) {
            alert("Date pickers not ready. Please try again.");
            return;
        }
        
        var startDatePicker = startDateEl.ej2_instances[0];
        var endDatePicker = endDateEl.ej2_instances[0];
        
        var startDate = startDatePicker.value;
        var endDate = endDatePicker.value;
        
        console.log("Start date:", startDate, "End date:", endDate);
        
        if (!startDate || !endDate) {
            alert("Please select both start and end dates");
            return;
        }
        
        // Show loading
        showElement(ELEMENT_IDS.RESEND_LOADING);
        hideElement(ELEMENT_IDS.RESEND_RESULTS_CONTAINER);
        hideElement(ELEMENT_IDS.RESEND_NO_RESULTS);
        hideElement(ELEMENT_IDS.RESEND_PROGRESS_CONTAINER);
        
        var requestData = {
            StartDate: startDate.toISOString(),
            EndDate: endDate.toISOString(),
            Page: 1,
            PageSize: 100
        };
        
        $.ajax({
            url: API_ENDPOINTS.GET_PAID_INVOICES,
            type: 'POST',
            contentType: 'application/json',
            data: JSON.stringify(requestData),
            success: function(response) {
                hideElement(ELEMENT_IDS.RESEND_LOADING);
                
                if (response.isError) {
                    logToServer("error", "Error fetching paid invoices for resend", { error: response.errorMessage });
                    alert("Error: " + response.errorMessage);
                    return;
                }
                
                resendRemittances.invoiceGroups = response.groups || [];
                resendRemittances.selectedContacts = [];
                
                if (resendRemittances.invoiceGroups.length === 0) {
                    showElement(ELEMENT_IDS.RESEND_NO_RESULTS);
                } else {
                    resendRemittances.renderResults();
                    showElement(ELEMENT_IDS.RESEND_RESULTS_CONTAINER);
                }
                
                resendRemittances.updateSelectedCount();
                var selectAllCb = getElement(ELEMENT_IDS.RESEND_SELECT_ALL);
                if (selectAllCb) selectAllCb.checked = false;
            },
            error: function(xhr, status, error) {
                logToServer("error", "AJAX error fetching paid invoices", { status: status, error: error });
                hideElement(ELEMENT_IDS.RESEND_LOADING);
                alert("Failed to fetch paid invoices. Please try again.");
            }
        });
    },

    /**
     * Renders the search results in the invoices list container
     */
    renderResults: function() {
        var container = getElement(ELEMENT_IDS.RESEND_INVOICES_LIST);
        if (!container) return;
        var html = '';
        
        this.invoiceGroups.forEach(function(group, index) {
            var invoiceCount = group.invoices ? group.invoices.length : 0;
            var totalFormatted = group.totalAmount ? group.totalAmount.toFixed(2) : '0.00';
            
            html += '<div class="resend-contact-group" style="border-bottom: 1px solid #eee; padding: 10px;">';
            html += '  <div style="display: flex; align-items: center;">';
            html += '    <input type="checkbox" class="resend-contact-checkbox" data-contact-id="' + group.contactId + '" ';
            html += '           onchange="resendRemittances.toggleContact(\'' + group.contactId + '\')" style="margin-right: 10px;">';
            html += '    <div style="flex: 1;">';
            html += '      <strong>' + (group.contactName || 'Unknown') + '</strong>';
            html += '      <span style="color: #666; margin-left: 10px;">(' + invoiceCount + ' invoice' + (invoiceCount !== 1 ? 's' : '') + ')</span>';
            html += '    </div>';
            html += '    <div style="text-align: right;">';
            html += '      <strong>$' + totalFormatted + '</strong>';
            html += '    </div>';
            html += '  </div>';
            
            if (group.contactEmail) {
                html += '  <div style="margin-left: 25px; color: #666; font-size: 12px;">' + group.contactEmail + '</div>';
            }
            
            // Show invoice details
            if (group.invoices && group.invoices.length > 0) {
                html += '  <div style="margin-left: 25px; margin-top: 5px; font-size: 12px; color: #888;">';
                group.invoices.slice(0, 3).forEach(function(inv) {
                    var paymentDate = inv.paymentDate ? new Date(inv.paymentDate).toLocaleDateString() : 'N/A';
                    html += '<span style="margin-right: 15px;">' + (inv.invoiceNumber || 'N/A') + ' - $' + (inv.amountPaid || 0).toFixed(2) + ' (' + paymentDate + ')</span>';
                });
                if (group.invoices.length > 3) {
                    html += '<span>...and ' + (group.invoices.length - 3) + ' more</span>';
                }
                html += '  </div>';
            }
            
            html += '</div>';
        });
        
        container.innerHTML = html;
    },

    toggleContact: function(contactId) {
        var index = this.selectedContacts.indexOf(contactId);
        if (index === -1) {
            this.selectedContacts.push(contactId);
        } else {
            this.selectedContacts.splice(index, 1);
        }
        this.updateSelectedCount();
        this.updateSelectAllCheckbox();
    },

    toggleSelectAll: function() {
        var selectAllChecked = document.getElementById("resendSelectAll").checked;
        var checkboxes = document.querySelectorAll(".resend-contact-checkbox");
        
        this.selectedContacts = [];
        
        if (selectAllChecked) {
            this.invoiceGroups.forEach(function(group) {
                resendRemittances.selectedContacts.push(group.contactId);
            });
        }
        
        checkboxes.forEach(function(cb) {
            cb.checked = selectAllChecked;
        });
        
        this.updateSelectedCount();
    },

    updateSelectAllCheckbox: function() {
        var selectAll = document.getElementById("resendSelectAll");
        selectAll.checked = this.selectedContacts.length === this.invoiceGroups.length && this.invoiceGroups.length > 0;
    },

    updateSelectedCount: function() {
        var count = this.selectedContacts.length;
        document.getElementById("resendSelectedCount").textContent = count + " contact" + (count !== 1 ? "s" : "") + " selected";
        document.getElementById("btnResendRemittancesSend").disabled = count === 0;
    },

    sendRemittances: function() {
        if (this.selectedContacts.length === 0) {
            alert("Please select at least one contact");
            return;
        }
        
        var startDatePicker = document.getElementById("resendStartDate").ej2_instances[0];
        var endDatePicker = document.getElementById("resendEndDate").ej2_instances[0];
        
        // Show progress
        document.getElementById("resendResultsContainer").style.display = "none";
        document.getElementById("resendProgressContainer").style.display = "block";
        document.getElementById("resendProgressMessage").textContent = "Sending " + this.selectedContacts.length + " remittance(s)...";
        document.getElementById("btnResendRemittancesSend").disabled = true;
        
        var requestData = {
            ContactIds: this.selectedContacts,
            StartDate: startDatePicker.value.toISOString(),
            EndDate: endDatePicker.value.toISOString()
        };
        
        $.ajax({
            url: API_ENDPOINTS.RESEND_REMITTANCE,
            type: 'POST',
            contentType: 'application/json',
            data: JSON.stringify(requestData),
            success: function(response) {
                document.getElementById("resendProgressContainer").style.display = "none";
                
                if (response.isError) {
                    alert("Error: " + response.message);
                    document.getElementById("resendResultsContainer").style.display = "block";
                    resendRemittances.updateSelectedCount();
                } else {
                    alert(response.message || "Remittances sent successfully!");
                    var dialog = document.getElementById("resendRemittancesDialog").ej2_instances[0];
                    dialog.hide();
                }
            },
            error: function(error) {
                document.getElementById("resendProgressContainer").style.display = "none";
                document.getElementById("resendResultsContainer").style.display = "block";
                resendRemittances.updateSelectedCount();
                console.error("Error sending remittances:", error);
                alert("Failed to send remittances. Please try again.");
            }
        });
    }
};

/* =============================================================================
   RE-RUN REPORT FEATURE
   Allows users to regenerate batch payment reports for already-paid invoices
   ============================================================================= */

/**
 * Re-run Report module
 * Handles searching for paid invoices and generating PDF/CSV reports
 */

export default resendRemittances;
window.resendRemittances = resendRemittances;
